/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Tenant-unique Academy5 / external student id
 */
export type HubSpotEnrollRequestExternalStudentId = string | null;
